import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { productBrief } from "../data/productBrief";
export function WorkshopsSection() {
  return <section className="section wash" id="workshops" aria-labelledby="workshops-heading" data-id="element-287" data-mp="16pmi5sj7mcrv">
      <div className="shell" data-id="element-288" data-mp="1boz4mc665htx">
        <div className="section-intro" data-id="element-289" data-mp="1bo66fzla00ne">
          <p className="eyebrow" data-id="element-290" data-mp="1bn4qphtbepzc">THE 10 WORKSHOPS</p>
          <h2 id="workshops-heading" data-id="element-291" data-mp="ezzuerm0y5z3">
            One skill per session, <span data-id="element-292" data-mp="j0jrxwaifblr">start to follow-up</span>
          </h2>
          <p data-id="element-293" data-mp="j138p9ofbty7">
            Ordered like a real sales conversation. Run them in sequence or pick the skill your
            team needs next.
          </p>
        </div>
        <ol className="workshop-list" data-id="element-294" data-mp="sqwh61t9rsy8">
          {productBrief.workshops.map(workshop => <li key={workshop.number} data-id="element-295" data-mp="3rgwr5u2bffhw">
              <span className="workshop-number" aria-hidden="true" data-id="element-296" data-mp="3rftyphpch4zv">
                {String(workshop.number).padStart(2, "0")}
              </span>
              <div data-id="element-297" data-mp="1strsyd82rde6">
                <h3 data-id="element-298" data-mp="1su9playnftmm">{workshop.title}</h3>
                <p data-id="element-299" data-mp="1sw48yku9vdol">{workshop.outcome}</p>
                <span className="workshop-vol" data-id="element-300" data-mp="1orwiai497nnq">VOLUME {workshop.volume}</span>
              </div>
            </li>)}
        </ol>
        <div className="section-action" data-id="element-301" data-mp="1k0512y6zmua9">
          <CtaButton href="#offer-details" data-id="element-302" data-mp="1f2mql3dbo705">
            See all 10 session plans — $27 <ArrowRightIcon size={18} aria-hidden="true" data-id="element-303" data-mp="1f0inuor5te1g" />
          </CtaButton>
        </div>
      </div>
    </section>;
}